import { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Glass panel with optional corner brackets — replaces shadcn `Card`
 * where the Stitch aesthetic is wanted.
 */
export const StitchPanel = ({
  children,
  className,
  brackets = true,
  glow = false,
}: {
  children: ReactNode;
  className?: string;
  brackets?: boolean;
  glow?: boolean;
}) => (
  <div
    className={cn(
      "relative rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-xl",
      glow && "shadow-[0_0_60px_-15px_hsl(var(--primary))]",
      className,
    )}
  >
    {brackets && (
      <>
        <span className="pointer-events-none absolute left-2 top-2 h-3.5 w-3.5 border-l-2 border-t-2 border-primary" />
        <span className="pointer-events-none absolute right-2 top-2 h-3.5 w-3.5 border-r-2 border-t-2 border-primary" />
        <span className="pointer-events-none absolute bottom-2 left-2 h-3.5 w-3.5 border-b-2 border-l-2 border-primary" />
        <span className="pointer-events-none absolute bottom-2 right-2 h-3.5 w-3.5 border-b-2 border-r-2 border-primary" />
      </>
    )}
    {children}
  </div>
);
